import React from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
/**
 * @typedef {import('../../App.d.ts').ComponentInformationAndDownloadsProps} ComponentInformationAndDownloadsProps
 */
/**
 *
 * @param {ComponentInformationAndDownloadsProps} props
 * @returns {Element}
 * @constructor
 */
export default ({
  image,
  text,
  button,
}) => {
  return (
    <Container>
      <div
        data-testid="information-and-downloads"
        className="dodo-component-information-and-downloads"
      >
        <div className="dodo-component-information-and-downloads__left">
          <img
            src={image.src}
            alt={image.alt ?? ''}
          />
        </div>

        <div className="dodo-component-information-and-downloads__right">
          <h3>{text.headline}</h3>
          <p>{text.description}</p>
          <div>
            <Button
              text={button.text}
              srText={button.srText}
              mode="secondary"
              icon={<IconAsChunk iconName="Externallink" />}
              href={button.href}
              rawElementProps={{ target: '_blank' }}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};
